import { Component, EventEmitter, Input, Output, OnInit, ElementRef, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { Validatable } from '../../../../../validations/validatable'
import { PaymentOption, PaymentOptions } from '../../../../models/payment-options'
import { ValidatedRadioButtonModel } from '../../../../../validations/validated-radio-button-group.component'
import { Notes } from '../../../../models/notes'
import { EnrollmentViewModel } from '../../../../models/enrollment-view-model'
import { EnrollmentGateway } from '../../../../gateways/enrollment-gateway'
import { NumericTextFieldValidator } from '../../../../../validations/numeric-text-field-validator'
import { NotBlankGenericFieldValidator } from '../../../../../validations/not-blank-generic-field-validator'
import { LengthTextFieldValidator } from '../../../../../validations/length-text-field-validator'
import { DateTextFieldValidator } from '../../../../../validations/date-text-field.validator'
import { AccountTypes, PaymentAccount } from '../../../../models/payment-account'
import { SubmitEnrollmentDataResponse } from '../../../../models/submit-enrollment-data-response'
import * as moment from 'moment'
import { CurrentUserGateway } from '../../../../../common/gateways/current-user-gateway'
import { PortalGlobals } from '../../../../../portalglobals'
@Component({
    selector: 'PhoneEnrollmentExtStep3',
    templateUrl: 'phone-enrollment-step3.component.html'
})
export class PhoneEnrollmentExtStep3Component implements OnInit {
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    paymentOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    @Input() paymentAccount: PaymentAccount = {} as PaymentAccount

    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef

    // @Output() onPaymentAccountChange: EventEmitter<PaymentAccount> = new EventEmitter<PaymentAccount>()
    //  @Output() onPaymentOptionChange: EventEmitter<string> = new EventEmitter<string>()
    routingNumberLengthValidator: LengthTextFieldValidator = new LengthTextFieldValidator(9)
    notBlankValidator: NotBlankGenericFieldValidator = new NotBlankGenericFieldValidator()
    numericValidator: NumericTextFieldValidator = new NumericTextFieldValidator()
    @Input() disabled: boolean = false
    @Input() paymentOption: string = ''
    notesModel = {} as Notes
    public IsAutomatciSocial: boolean
    public IsAUTOMATIC_RAILROAD: boolean
    public IsElectronicFund: boolean
    public IsMonthly: boolean
    public IsRblLISYes: boolean
    public IsRblLISNo: boolean
    public rblLIS: ValidatedRadioButtonModel[] = []
    hasError: boolean
    //IsSelectPlan: boolean
    currentdate: string
    insuranceComapny: string
    spnIsBeneficiary: string
    spnIsAre: string
    spnYourMediBeneficiary: string
    spnDoDoes: string
    spnIsAreCapt: string
    spnIsBeneficiaryYour: string
    spnIsQualify: string
    spnYouThey: string
    spnYourTheir: string
    spnHasHave: string
    spnIsReside: string
    spnyouheshe: string
    spnyourhisher: string
    spnYourBeneficiaryNew: string
    spnYouenrollee: string
    spnYouTheEnrolee: string
    spnYourenrollee: string
    spnyouhisher: string
    spnyouthem: string
    spnauthorize: string
    spndodoes: string
    spnyouenrollee: string
    AgentFullName: string
    checkPlanyear: boolean = false
    ErrorMessages: any[]
    spnYourenrolle: string
    spnyourenrolles: string
    spnYouTheenrollee: string
    spnyouenrolleesmall: string
    spnyoutheenrolleessmall: string

    accountInfoFormIsVisible() {
        return this.paymentOption === 'ELECTRONIC_FUND_TRANSFER'
    }
    accountTypeOptions: ValidatedRadioButtonModel[] = Object.keys(AccountTypes).map((accountTypeKey) => {
        return { value: accountTypeKey, htmlLabel: AccountTypes[accountTypeKey] }
    })
    ShowCurrentYearScript: boolean = false
    isShowScript: boolean = false
    constructor(
        private _enrollementGateway: EnrollmentGateway,
        private router: Router,
        public _global: PortalGlobals,
        private _currentUserGateway: CurrentUserGateway
    ) {
        this.rblLIS.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.IsAutomatciSocial = false
        this.IsAUTOMATIC_RAILROAD = false
        this.IsElectronicFund = false
        this.IsMonthly = false
        this.IsRblLISYes = false
        this.IsRblLISNo = false
        //this.IsSelectPlan = true
        this.currentdate = moment().format('MM/DD/YYYY')
    }
    ngOnInit() {
        if (this._global === undefined || this._global.currentUser === undefined) {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this._global.currentUser = user
                    this.insuranceComapny = this._global.currentUser.insuranceCompanyName
                }
            })
        }
        if (this._global.currentUser !== undefined) {
            this.insuranceComapny = this._global.currentUser.insuranceCompanyName
        }
        if (Number(this._global.selectedPlanYear) === this._global.PreviousPlanYear) {
            this.ShowCurrentYearScript = true
        }
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        this.AgentFullName =
            (this.enrollment.APPFN === null ? '' : this.enrollment.APPFN) + ' ' + (this.enrollment.APPLN === null ? '' : this.enrollment.APPLN)
        if (this.enrollment.PLANYEAR === '2019') {
            this.checkPlanyear = true
        } else {
            this.checkPlanyear = false
        }
        this.setScript()
        this.paymentOptions = [
            {
                value: 'Direct Bill',
                htmlLabel: 'Receive a bill in the mail and pay by check or set up automatic payment through a credit card.',
                disabled: this.disabled
            },
            {
                value: 'Automatic Bank Draft Withdrawal',
                htmlLabel:
                    'Automatic deduction from ' +
                    this.spnyourenrolles +
                    ' checking or savings account. ' +
                    this.spnYouTheenrollee +
                    ' ' +
                    this.spnIsAre +
                    ' able to enroll in this option during the call today.',
                disabled: this.disabled
            },
            {
                value: 'Deduction from Social Security Check',
                htmlLabel:
                    'Automatic deduction from ' +
                    this.spnIsBeneficiaryYour +
                    ' monthly Social Security benefit. ' +
                    this.spnYouenrollee +
                    ' ' +
                    this.spnIsAre +
                    ' able to enroll in this option during the call today.',
                disabled: this.disabled
            },
            {
                value: 'Deduction from Railroad Retirement Board',
                htmlLabel:
                    'Automatic deduction from ' +
                    this.spnIsBeneficiaryYour +
                    ' Railroad Retirement benefit. ' +
                    this.spnYouenrollee +
                    ' ' +
                    this.spnIsAre +
                    ' able to enroll in this option during the call today.',
                disabled: this.disabled
            }
        ]
        this.paymentOptionChanged(this.enrollment.paymentOption)
        //this.ShowOptionsRblLIS(this.enrollment.RBLLIS)
    }
    validateForm(): boolean {
        this.hasError = false
        this.ErrorMessages = [] as any[]
        if (this.enrollment.PWO === undefined || this.enrollment.PWO === '' || this.enrollment.PWO === null) {
            this.ErrorMessages.push('Payment Type is required')
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        }
        if (this.enrollment.PWO === 'Automatic Bank Draft Withdrawal') {
            if (this.enrollment.ACCHOLDERNAME === undefined || this.enrollment.ACCHOLDERNAME === '') {
                this.ErrorMessages.push('Please enter valid Account Name')
                this.hasError = true
            }
            if (this.enrollment.ACCHOLDERNAME !== undefined && this.enrollment.ACCHOLDERNAME !== '' && this.enrollment.ACCHOLDERNAME !== null) {
                let checkACCHOLDERNAME = this.enrollment.ACCHOLDERNAME,
                    regexACCHOLDERNAMEVal = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isACCHOLDERNAMEValid = regexACCHOLDERNAMEVal.test(checkACCHOLDERNAME)
                if (!isACCHOLDERNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Account Name on Bank Account is invalid')
                }
            }
            if (this.enrollment.EFTTYPE === undefined || this.enrollment.EFTTYPE === '') {
                this.ErrorMessages.push('Please select Account type')
                this.hasError = true
            }
            if (this.enrollment.FININSTNAME === undefined || this.enrollment.FININSTNAME === '') {
                this.ErrorMessages.push('Please enter valid Financial Institution')
                this.hasError = true
            }
            if (this.enrollment.FININSTNAME !== undefined && this.enrollment.FININSTNAME !== '' && this.enrollment.FININSTNAME !== null) {
                let checkFININSTNAME = this.enrollment.FININSTNAME,
                    regexFININSTNAME = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isFININSTNAMEValid = regexFININSTNAME.test(checkFININSTNAME)
                if (!isFININSTNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Financial Institution on Bank Account is invalid')
                }
            }
            if (this.enrollment.ROUTINGNB === undefined || this.enrollment.ROUTINGNB === '') {
                this.ErrorMessages.push('Please enter valid Routing Number')
                this.hasError = true
            }
            if (this.enrollment.ROUTINGNB !== undefined && this.enrollment.ROUTINGNB !== '' && this.enrollment.ROUTINGNB !== null) {
                let checkROUTINGNB = this.enrollment.ROUTINGNB,
                    regexROUTINGNB = new RegExp('^[0-9]*$')
                let isROUTINGNBValid = regexROUTINGNB.test(checkROUTINGNB)
                if (!isROUTINGNBValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Routing Number is invalid')
                }
            }
            if (this.enrollment.ROUTINGNB !== undefined && this.enrollment.ROUTINGNB !== '' && this.enrollment.ROUTINGNB !== null) {
                if (this.enrollment.ROUTINGNB.length !== 9) {
                    this.hasError = true
                    this.ErrorMessages.push('Routing number must be 9 numbers')
                }
            }

            if (this.enrollment.ACCOUNTNB === undefined || this.enrollment.ACCOUNTNB === '') {
                this.ErrorMessages.push('Please enter valid Account Number')
                this.hasError = true
            }
            if (this.enrollment.ACCOUNTNB !== undefined && this.enrollment.ACCOUNTNB !== '' && this.enrollment.ACCOUNTNB !== null) {
                let checkACCOUNTNB = this.enrollment.ACCOUNTNB,
                    regexACCOUNTNB = new RegExp('[0-9]{6}')
                let isACCOUNTNBValid = regexACCOUNTNB.test(checkACCOUNTNB)
                if (!isACCOUNTNBValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Account Number is invalid')
                }
            }
        }
        //if (this.enrollment.RBLLIS === undefined || this.enrollment.RBLLIS === '' || this.enrollment.RBLLIS === null) {
        //    this.hasError = true
        //    this.ErrorMessages.push('Please select LIS option')
        //}

        return this.hasError
    }
    onBack(): void {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/ext/Step2'])
    }
    formSubmit(): void {
        this.ErrorMessages = [] as any[]
        this.enrollment.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollment.STEPCODE = '33'
        if (this.enrollment.PWO !== 'Automatic Bank Draft Withdrawal') {
            this.resetBankDeatils()
        }
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        if (!this.validateForm()) {
            this._enrollementGateway.UpdateEnrollmentData(this.enrollment).subscribe((model: SubmitEnrollmentDataResponse) => {
                let response = model
                if (response !== undefined) {
                    if (response.Errors !== undefined && response.Errors.length > 0) {
                        this.hasError = false

                        for (let i = 0; i < response.Errors.length; i++) {
                            this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                        }
                        this.hasError = true
                        this.focusableEleTop.nativeElement.focus()
                    } else {
                        if (response.EnrollmentKey !== undefined && response.EnrollmentKey !== '' && response.EnrollmentKey !== null) {
                            this.enrollment.ENROLLKEY = response.EnrollmentKey
                            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                            this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/ext/Step4'])
                        } else {
                            this.ErrorMessages.push('Error while submitting data, please try again.')
                            this.hasError = true
                            this.focusableEleTop.nativeElement.focus()
                        }
                    }
                } else {
                    this.ErrorMessages.push('Error while submitting data, please try again.')
                    this.hasError = true
                    this.focusableEleTop.nativeElement.focus()
                }
            })
        } else {
            this.focusableEleTop.nativeElement.focus()
        }
    }
    //paymentFormChange(paymentAccount: PaymentAccount) {
    //    this.paymentAccount = paymentAccount
    //    this.onPaymentAccountChange.emit(paymentAccount)
    //}

    paymentOptionChanged(option: string) {
        this.enrollment.PWO = option
        // this.onPaymentOptionChange.emit(option)
        if (option === 'Deduction from Social Security Check') {
            this.IsAutomatciSocial = true
            this.IsAUTOMATIC_RAILROAD = false
            this.IsElectronicFund = false
            this.IsMonthly = false
            this.isShowScript = true
            //this.IsSelectPlan = false
        }
        if (option === 'Deduction from Railroad Retirement Board') {
            this.IsAutomatciSocial = false
            this.IsAUTOMATIC_RAILROAD = true
            this.IsElectronicFund = false
            this.IsMonthly = false
            this.isShowScript = true
            //this.IsSelectPlan = false
        }
        if (option === 'Automatic Bank Draft Withdrawal') {
            this.IsAutomatciSocial = false
            this.IsAUTOMATIC_RAILROAD = false
            this.IsElectronicFund = true
            this.IsMonthly = false
            this.isShowScript = true
            //this.IsSelectPlan = false
        }
        if (option === 'Direct Bill') {
            this.IsAutomatciSocial = false
            this.IsAUTOMATIC_RAILROAD = false
            this.IsElectronicFund = false
            this.IsMonthly = true
            this.isShowScript = true
            //this.IsSelectPlan = false
        }
        this.enrollment.paymentOption = option
    }
    resetBankDeatils() {
        this.enrollment.ACCHOLDERNAME = ''
        this.enrollment.EFTTYPE = ''
        this.enrollment.FININSTNAME = ''
        this.enrollment.ROUTINGNB = ''
        this.enrollment.ACCOUNTNB = ''

        this.paymentAccount.holderName = ''
        this.paymentAccount.institution = ''
        this.paymentAccount.number = ''
        this.paymentAccount.routingNumber = ''
        this.paymentAccount.type = null
        this.paymentAccount = {} as PaymentAccount
        this.enrollment.paymentAccount = this.paymentAccount
    }
    //ShowOptionsRblLIS(val: any) {
    //    if (val === 'Yes') {
    //        this.IsRblLISYes = true
    //        this.IsRblLISNo = false
    //    }
    //    if (val === 'No') {
    //        this.IsRblLISYes = false
    //        this.IsRblLISNo = true
    //    }
    //    this.enrollment.RBLLIS = val
    //}
    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }
    setScript() {
        if (this.enrollment.RBLBENFE === 'Yes') {
            this.spnIsBeneficiary = 'you '
            this.spnIsAre = 'are '
            this.spnYourMediBeneficiary = 'your '
            this.spnDoDoes = 'Do '
            this.spnIsAreCapt = 'Are '
            this.spnIsBeneficiaryYour = 'your '
            this.spnIsQualify = 'qualify '
            this.spnYouThey = 'you '
            this.spnYourTheir = 'your '
            this.spnHasHave = 'have '
            this.spnIsReside = ''
            this.spnyouheshe = 'you'
            this.spnyourhisher = 'your'
            this.spnYourBeneficiaryNew = 'your '
            this.spnYouenrollee = 'You'
            this.spnYourenrollee = 'Your'
            this.spnyouhisher = 'you'
            this.spnyouthem = 'you'
            this.spnauthorize = 'authorize'
            this.spndodoes = 'do'
            this.spnyouenrollee = 'you'
            this.spnYouTheEnrolee = 'You'
            this.spnYourenrolle = 'Your'
            this.spnyourenrolles = 'your'
            this.spnYouTheenrollee = 'You'
            this.spnyouenrolleesmall = 'you'
            this.spnyoutheenrolleessmall = 'you'
        }
        if (
            this.enrollment.RBLBENFE === 'No' &&
            this.AgentFullName !== ' ' &&
            this.AgentFullName !== '' &&
            this.AgentFullName !== 'undefined undefined'
        ) {
            this.spnIsBeneficiary = this.AgentFullName
            this.spnIsAre = 'is '
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s '
            this.spnDoDoes = 'Does '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = 'the enrollee’s'
            this.spnIsQualify = 'qualifies '
            this.spnYouThey = 'they '
            this.spnYourTheir = 'their '
            this.spnHasHave = 'has '
            this.spnIsReside = '(s)'
            this.spnauthorize = 'authorizes'
            this.spnYouenrollee = 'Enrollee'
            this.spnYourenrollee = 'The enrollee’s'
            this.spnYourBeneficiaryNew = 'Medicare beneficiary '
            this.spndodoes = 'does'
            this.spnyouenrollee = 'the enrollee'
            this.spnYouTheEnrolee = 'The enrollee'
            this.spnYourenrolle = 'enrollee'
            this.spnyourenrolles = 'enrollee’s'
            this.spnYouTheenrollee = 'The enrollee'
            this.spnyouenrolleesmall = 'enrollee'
            this.spnyoutheenrolleessmall = 'the enrollee’s'
            if (this.enrollment.TITLE === 'Mr' || this.enrollment.APPGEN === 'M') {
                this.spnyouheshe = 'he'
                this.spnyourhisher = 'his'
                this.spnyouhisher = 'his'
                this.spnyouthem = 'them'
            } else if (this.enrollment.TITLE === 'Mrs' || this.enrollment.TITLE === 'Ms' || this.enrollment.APPGEN === 'F') {
                this.spnyouheshe = 'she'
                this.spnyourhisher = 'her'
                this.spnyouhisher = 'her'
                this.spnyouthem = 'them'
            } else {
                this.spnyouheshe = '(he, she)'
                this.spnyourhisher = '(his, her)'
                this.spnyouhisher = '(his, her)'
                this.spnyouthem = 'them'
            }
        }
        if (
            this.enrollment.RBLBENFE === 'No' &&
            (this.AgentFullName === ' ' || this.AgentFullName === 'undefined undefined' || this.AgentFullName === '')
        ) {
            this.spnIsBeneficiary = 'enrollee'
            this.spnIsAre = 'is'
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s'
            this.spnDoDoes = 'Does '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = 'the enrollee’s'
            this.spnIsQualify = 'qualifies'
            this.spnYouThey = 'they'
            this.spnYourTheir = 'their'
            this.spnHasHave = 'has'
            this.spnIsReside = '(s)'
            this.spnyouheshe = '(he, she)'
            this.spnyourhisher = '(his, her)'
            this.spnYourBeneficiaryNew = 'Medicare beneficiary'
            this.spnYouenrollee = 'Enrollee'
            this.spnYourenrollee = 'The enrollee’s'
            this.spnyouhisher = '(his, her)'
            this.spnyouthem = '(you, them)'
            this.spnauthorize = 'authorize'
            this.spndodoes = 'does'
            this.spnyouenrollee = 'the enrollee'
            this.spnYouTheEnrolee = 'The enrollee'
            this.spnYourenrolle = 'enrollee'
            this.spnyourenrolles = 'enrollee’s'
            this.spnYouTheenrollee = 'The enrollee'
            this.spnyouenrolleesmall = 'enrollee'
            this.spnyoutheenrolleessmall = 'the enrollee’s'
        }
    }
}
